import { createIcon } from '@chakra-ui/icon';
import * as React from 'react';
export var CardMastercardIcon = createIcon({
  displayName: 'CardMastercardIcon',
  viewBox: '0 0 32 20',
  path: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    height: "19",
    rx: "1.5",
    stroke: "currentColor",
    width: "31",
    x: "0.5",
    y: "0.5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: "12",
    cy: "10",
    fill: "none",
    r: "5.875",
    stroke: "currentColor",
    strokeWidth: "1.25"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: "20",
    cy: "10",
    fill: "none",
    r: "5.875",
    stroke: "currentColor",
    strokeWidth: "1.25"
  }))
});
//# sourceMappingURL=CardMastercard.js.map